import {
  startRegistration,
  startAuthentication,
  browserSupportsWebAuthn,
} from '@simplewebauthn/browser';
import { apiV2 } from '../lib/baseAxios';

export { browserSupportsWebAuthn };

// --- Authentication (unauthenticated flow) ---

export const passkeySignIn = async (): Promise<string> => {
  // Step 1: Get authentication options from server
  const optionsResponse = await apiV2.post('auth/passkey/options');
  const { sessionId, ...options } = optionsResponse.data.data;

  // Step 2: Trigger browser passkey prompt
  const credential = await startAuthentication({ optionsJSON: options });

  // Step 3: Verify with server
  const verifyResponse = await apiV2.post('auth/passkey/verify', {
    sessionId,
    credential,
  });

  const { token } = verifyResponse.data.data;
  if (!token) throw new Error('No token received');
  return token;
};

// --- Registration (authenticated flow) ---

export interface PasskeyCredentialInfo {
  _id: string;
  credentialId: string;
  friendlyName: string;
  deviceType: string;
  backedUp: boolean;
  createdAt: string;
  lastUsedAt?: string;
  transports?: string[];
}

export const registerPasskey = async (
  friendlyName: string = 'Passkey',
): Promise<void> => {
  // Step 1: Get registration options
  const optionsResponse = await apiV2.post('account/passkeys/register/options');
  const options = optionsResponse.data.data;

  // Step 2: Trigger browser registration prompt
  const credential = await startRegistration({ optionsJSON: options });

  // Step 3: Send credential to server for verification and storage
  await apiV2.post('account/passkeys/register/verify', {
    credential,
    friendlyName,
  });
};

export const listPasskeys = async (): Promise<PasskeyCredentialInfo[]> => {
  const response = await apiV2.get('account/passkeys');
  return response.data.data;
};

export const deletePasskey = async (id: string): Promise<void> => {
  await apiV2.delete(`account/passkeys/${id}`);
};

export const renamePasskey = async (
  id: string,
  friendlyName: string,
): Promise<void> => {
  await apiV2.patch(`account/passkeys/${id}`, { friendlyName });
};
